import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Rect } from 'src/app/classes/rect.class';
import { enableBodyScroll } from 'src/app/lib/toggle-body-scroll';
import { BrowserService } from 'src/app/services/browser.service';
import { StateService } from 'src/app/services/state.service';
import { AssetPageComponent } from '../../gallery-shared/pages/asset-page/asset-page.component';
import { AssetTransitionService } from '../services/asset-transition.service';

@Injectable({
  providedIn: 'root',
})
export class AssetPageDeactivation {
  constructor(
    private assetTransition: AssetTransitionService,
    private state: StateService,
    private browserService: BrowserService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  async canDeactivate(
    component: AssetPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Promise<boolean> {
    this.document.body.classList.remove('noscroll-asset-page');
    if (!currentRoute.data.data?.asset) return true;
    const asset = this.state.currentAsset;

    if (this.browserService.urlIsAssetUrl(nextState.url)) {
      // Going to another asset
      // this.document.body.classList.add('noscroll-asset-page');
      return true;
    }
    enableBodyScroll('asset-page');
    if (!this.browserService.urlIsGalleryUrl(nextState.url)) return true; // Not going back to the gallery page

    const el = document.querySelector('.asset-container.active .asset')?.getBoundingClientRect();
    if (!el) {
      console.warn('Couldnt find .asset-container.active .asset');
      return true;
    }
    const rect = Rect.fromDOMRect(el);
    const embedMode = nextState.url.includes('/embed');
    if (!embedMode) await this.assetTransition.transitionFromAsset(asset, rect);
    return true;
  }
}
